import { useState } from 'react'
import { useVersionCheck } from '../hooks/useVersionCheck'
import UpdateBanner from './UpdateBanner'

/**
 * Polls the deployed build id and, when a newer release is available, shows the
 * dismissible refresh toast (#533). Dismissal only hides it for the current
 * page view; a later poll (or a chunk-load failure that auto-reloads) still
 * gets the user onto the new version.
 */
const VersionUpdateBanner = () => {
  const updateAvailable = useVersionCheck()
  const [dismissed, setDismissed] = useState(false)

  return (
    <UpdateBanner
      show={updateAvailable && !dismissed}
      onRefresh={() => window.location.reload()}
      onDismiss={() => setDismissed(true)}
    />
  )
}

export default VersionUpdateBanner
